import { render, staticRenderFns } from "./buscaEquipamento.vue?vue&type=template&id=58e956d5&"
import script from "./buscaEquipamento.vue?vue&type=script&lang=js&"
export * from "./buscaEquipamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports